/* LBL Lichter fase 1 (24 okt 2026): swipe-voortgangsbalkje.
   Zet onder een horizontaal scrollende rij een dunne lijn met een actief segment, zodat je op mobiel ziet dat er meer te swipen valt.
   Gebruik: data-lbl-swipe op de scroller. Productgalerijen (product-gallery scroll-carousel) worden vanzelf herkend, ook in de quick-view.
   Verbergt zichzelf als niets scrolt, alleen op mobiel (CSS), passief, geen eigen animatie. Terugdraaien: script-regel uit layout/theme.liquid halen. */
(function () {
  var SEL = '[data-lbl-swipe], product-gallery scroll-carousel';
  function setup(sc) {
    if (sc.__lblSw) return;
    sc.__lblSw = true;
    var bar = document.createElement('div');
    bar.className = 'lbl-sw';
    bar.hidden = true;
    bar.setAttribute('aria-hidden', 'true');
    var thumb = document.createElement('span');
    thumb.className = 'lbl-sw__t';
    bar.appendChild(thumb);
    var gal = sc.closest('product-gallery');
    if (gal) bar.classList.add('lbl-sw--pdp');
    sc.parentNode.insertBefore(bar, sc.nextSibling);
    var raf = 0;
    function draw() {
      raf = 0;
      var max = sc.scrollWidth - sc.clientWidth;
      var on = max > 8 && sc.clientWidth > 0;
      if (bar.hidden === on) {
        bar.hidden = !on;
        if (gal) gal.classList.toggle('lbl-sw-host', on);
      }
      if (!on) return;
      var w = Math.max(12, Math.min(100, sc.clientWidth / sc.scrollWidth * 100));
      var p = Math.max(0, Math.min(1, Math.abs(sc.scrollLeft) / max));
      thumb.style.width = w + '%';
      thumb.style.transform = 'translateX(' + (p * (100 / w * (100 - w))).toFixed(2) + '%)';
    }
    function req() { if (!raf) raf = requestAnimationFrame(draw); }
    sc.addEventListener('scroll', req, { passive: true });
    if (window.ResizeObserver) {
      var ro = new ResizeObserver(req);
      ro.observe(sc);
      if (sc.firstElementChild) ro.observe(sc.firstElementChild);
    } else { window.addEventListener('resize', req, { passive: true }); }
    window.addEventListener('load', req);
    draw();
  }
  function scan(root) {
    if (root.nodeType !== 1) return;
    if (root.matches && root.matches(SEL)) setup(root);
    var list = root.querySelectorAll ? root.querySelectorAll(SEL) : [];
    for (var i = 0; i < list.length; i++) setup(list[i]);
  }
  function init() {
    scan(document.documentElement);
    if (!window.MutationObserver) return;
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) for (var j = 0; j < muts[i].addedNodes.length; j++) scan(muts[i].addedNodes[j]);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
